/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LiveMetricsFromJSON, LiveMetricsToJSON } from './LiveMetrics';
/**
 * Check if a given object implements the LiveResponse interface.
 */
export function instanceOfLiveResponse(value) {
    if (!('fetchedAt' in value) || value['fetchedAt'] === undefined)
        return false;
    if (!('live' in value) || value['live'] === undefined)
        return false;
    return true;
}
export function LiveResponseFromJSON(json) {
    return LiveResponseFromJSONTyped(json, false);
}
export function LiveResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fetchedAt': json['fetched_at'],
        'live': LiveMetricsFromJSON(json['live']),
    };
}
export function LiveResponseToJSON(json) {
    return LiveResponseToJSONTyped(json, false);
}
export function LiveResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fetched_at': value['fetchedAt'],
        'live': LiveMetricsToJSON(value['live']),
    };
}
